import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { isDisplayNameVisible, isNameReadOnly } from '../../../base/config/functions.any';
import { isScreenShareParticipantById } from '../../../base/participants/functions';
import { isToolboxVisible } from "../../../toolbox/functions.web";
import StatusIndicatorsMobile from "./StatusIndicatorsMobile";
import DisplayNameMobile from "../../../display-name/components/web/DisplayNameMobile";
const useStyles = makeStyles()(() => {
    return {
        container: {
            display: 'flex',
            '& > *:not(:last-child)': {
                marginRight: '4px'
            }
        },
        nameContainer: {
            display: 'flex',
            overflow: 'hidden',
            opacity: "1",
            '&>div': {
                display: 'flex',
                overflow: 'hidden'
            }
        },
        indicatorsContainer2: {
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            marginLeft: "8px",
        },
        invisible: {
            opacity: "0",
            transition: "opacity .6s ease-in-out",
        },
    };
});
const ThumbnailBottomIndicatorsMobile = ({ className, local, participantId, showStatusIndicators = true, thumbnailType, }) => {
    const { classes: styles, cx } = useStyles();
    const _allowEditing = !useSelector(isNameReadOnly);
    const _defaultLocalDisplayName = interfaceConfig.DEFAULT_LOCAL_DISPLAY_NAME;
    const _showDisplayName = useSelector(isDisplayNameVisible);
    const isVirtualScreenshareParticipant = useSelector((state) => isScreenShareParticipantById(state, participantId));
    const toolboxVisible = useSelector(isToolboxVisible);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cx(className, 'bottom-indicators', !toolboxVisible && styles.invisible) },
            showStatusIndicators && React.createElement(StatusIndicatorsMobile, { audio: !isVirtualScreenshareParticipant, participantID: participantId, moderator: false, screenshare: isVirtualScreenshareParticipant, thumbnailType: thumbnailType }),
            _showDisplayName && (React.createElement("span", { className: styles.nameContainer },
                React.createElement(DisplayNameMobile, { allowEditing: local ? _allowEditing : false, displayNameSuffix: local ? _defaultLocalDisplayName : '', elementID: local ? 'localDisplayName' : `participant_${participantId}_name`, participantID: participantId, thumbnailType: thumbnailType }))))));
};
export default ThumbnailBottomIndicatorsMobile;
